export default class OpeningHours {
  constructor(el) {
    this.el = el;
    this.init();
    this.initEvents();
  }

  init() {
    this.showTables();
  }

  initEvents() {
    var select = this.el.querySelector("select");

    select.removeEventListener("change", (e) => this.handleChange(e));

    select.addEventListener("change", (e) => this.handleChange(e));
  }

  handleChange(e = {}) {
    this.showTables();
  }

  showTables() {
    var selectvalue = this.el.querySelector("select").value.toLowerCase();
    var tables = this.el.querySelectorAll(".c-container");

    tables.forEach((table) => {
      var accommodation = table.dataset.accommodation;
      if (accommodation != null && accommodation.includes(selectvalue)) {
        table.style.display = "block";
      } else {
        table.style.display = "none";
      }
    });
  }
}
